import {entities} from "./cnda/shelter";

const _ = require('lodash')

export default {
    id: 'C',
    name: 'CNDA',
    description: '',
    languages: ['fr', 'en'],
    //numberOfDecimals: 0,
    entities: _.concat(
        [
            require('./cnda/exercise').entity,
            require('./cnda/zone').entity,
            require('./cnda/function').entity,
            require('./cnda/organizationType').entity,
            require('./cnda/refuge').entity,
            require('./cnda/animal/race').entity,
            require('./cnda/animal/compatibility').entity,
            require('./cnda/animal/character').entity,
            require('./cnda/animal/handicap').entity,
            require('./cnda/animal/animal').entity,
            require('./cnda/animal/animal').animalCompatibilityEvaluationEntity,
            require('./cnda/bank').entity,
            require('./cnda/kp/accountsGroup').entity,
            require('./cnda/kp/analyticalCode').entity,
            require('./cnda/flow/accountingEntries').entity,
            require('./cnda/flow/bankFlow').entity,
            require('./cnda/batch/batch').entity,
            require('./cnda/entriesExtraction').entity,
            require('./cnda/natureOfHelp').entity,
            require('./cnda/typeOfProperty').entity,
            require('./cnda/dashboard').entity,
            require('./cnda/colleagueFile').entity,
            require('./cnda/liberality/modules/expenseCategory').entity,
        ],
        require('./cnda/shelter').entities,
        require('./cnda/animal/animalType').entities,
        require('./cnda/adhesion/adhesion').entities,
        require('./cnda/adhesion/modules/membershipFee').entities,
        require('./cnda/liberality/liberalityFile').entities,
        require('./cnda/liberality/liberalityPresentation').entities,
        require('./cnda/liberality/fileCategory').entities,
        require('./cnda/liberality/assetStatus').entities,
        require('./cnda/liberality/liberalityAdvance').entities,
        require('./cnda/liberalityArchive/liberalityFile').entities,
        require('./cnda/liberalityArchive/liberalityPresentation').entities,
        require('./cnda/staticEntities').dependencies,
        require('./cnda/organization').entities,
        //require('./cnda/newOrganization').entities,
        require('./cnda/contactsModules').entities,
        require('./cnda/kp/accountsTemplate').entities,
        require('./cnda/invoice/registration').entities,
        require('./cnda/cuser').entities,
        require('./cnda/capacity').entities,
        require('./cnda/reliefFund/reliefFund').entities,
        require('./cnda/reliefFund/payment').entities
    ),
    modules: _.concat(
        [
            // Configuration
            require('./cnda/exercise').module_,
            require('./cnda/zone').module_,
            require('./cnda/organizationType').module_,
            require('./cnda/function').module_,
            require('./cnda/bank').module_,
            require('./cnda/natureOfHelp').module_,
            require('./cnda/typeOfProperty').module_,
            //Animaux
            require('./cnda/animal/animalType').module_,
            require('./cnda/animal/race').module_,
            require('./cnda/animal/compatibility').module_,
            require('./cnda/animal/character').module_,
            require('./cnda/animal/handicap').module_,
            require('./cnda/animal/animal').module_,
            // Annuaire
            require('./cnda/organization').module_,
            //require('./cnda/newOrganization').newModule_,
            require('./cnda/shelter').module_,
            require('./cnda/refuge').module_,
            require('./cnda/cuser').administratorModule,
            require('./cnda/capacity').administratorModule,
            require('./cnda/contactsModules').administratorModule,
            // Mon classeur
            //require('./cnda/cuser').profileModule,
            require('./cnda/organization').userModule,
            require('./cnda/shelter').userModule_,
            require('./cnda/cuser').userModule,
            require('./cnda/capacity').userModule,
            //require('./cnda/cuser').profileModule
        ],
        [
            require('./cnda/contactsModules').userModule,
        ],
        // Adhésion
        [
            require('./cnda/adhesion/modules/application').module_,
            require('./cnda/adhesion/modules/file').module_,
            require('./cnda/adhesion/modules/membershipFee').module_,
        ],
        // Libéralités
        [
            require('./cnda/liberality/modules/fileCategory').module_,
            require('./cnda/liberality/modules/assetStatus').module_,
            require('./cnda/liberality/modules/expenseCategory').module_,
            require('./cnda/liberality/modules/file').module_,
            require('./cnda/liberality/modules/asset').module_,
            require('./cnda/liberality/modules/beneficiary').module_,
            require('./cnda/liberality/modules/presentation').module_,
            require('./cnda/liberality/modules/decision').module_,
            require('./cnda/liberality/modules/report').module_,
            require('./cnda/liberality/modules/advance').module_,
            require('./cnda/liberality/modules/reversion').module_,
            require('./cnda/liberality/modules/supportModule').module_,
        ],
        // Libéralités (archive)
        [
            require('./cnda/liberalityArchive/modules/file').module_,
            require('./cnda/liberalityArchive/modules/presentation').module_,
            require('./cnda/liberalityArchive/modules/decision').module_,
            require('./cnda/liberalityArchive/modules/report').module_,
            require('./cnda/liberalityArchive/modules/supportModule').module_,
        ],
        [
            require('./cnda/reliefFund/modules/submission').module_,
            require('./cnda/reliefFund/modules/study').module_,
            require('./cnda/reliefFund/modules/decision').module_,
            require('./cnda/reliefFund/modules/payment').module_,
            require('./cnda/reliefFund/modules/validation').module_,
            require('./cnda/reliefFund/modules/followUp').module_,
        ],
        [
            // Facture
            require('./cnda/invoice/registration').module_,
            require('./cnda/invoice/control').module_,
            require('./cnda/invoice/validation').module_,
            require('./cnda/invoice/invoiceFollowUp').module_,
            // Bank
            require('./cnda/batch/generation').module_,
            require('./cnda/batch/control').module_,
            require('./cnda/batch/payment').module_,
            require('./cnda/flow/bankFlow').module_,
            // Accounting
            require('./cnda/kp/accountsGroup').module_,
            require('./cnda/kp/analyticalCode').module_,
            require('./cnda/kp/accountsTemplate').module_,
            require('./cnda/flow/accountingEntries').module_,
            require('./cnda/entriesExtraction').module_,
            //KP
            require('./cnda/invoice/invoiceKpModule').module_
        ]
    ),
    jobs: [
        require('./cnda/jobs/adaptShelterCollection').job,
        require('./cnda/jobs/adaptCUserCollection').job,
        require('./cnda/jobs/adaptOrganizationCollection').job,
        require('./cnda/jobs/adaptBroadcastListPlatformCollection').job,
        require('./cnda/jobs/adaptAnimalCompatibilities').job,
        require('./cnda/jobs/adaptAnimalBirthYears').job,
        require('./cnda/jobs/adaptAnimalBirthDates').job,
        require('./cnda/jobs/adaptRemovedActivities').job,
        require('./cnda/jobs/initAssociationsMemberSize').job,
        require('./cnda/jobs/injectExternalApiMockData').job
    ]
}
